import React,{useState} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMail,FiArrowRight,FiCheck}=FiIcons;

const LeadCaptureSection=()=> {
  const [email,setEmail]=useState('');
  const [interests,setInterests]=useState([]);
  const [isSubmitted,setIsSubmitted]=useState(false);
  const [isLoading,setIsLoading]=useState(false);
  const [error,setError]=useState('');

  const interestOptions=[
    "I'm a founder/entrepreneur",
    "I'm a creative professional",
    "I have ADHD",
    "I'm autistic",
    "I juggle multiple projects",
    "I struggle with traditional productivity tools"
  ];

  const handleInterestToggle=(interest)=> {
    setInterests(prev=> 
      prev.includes(interest) 
        ? prev.filter(i=> i !==interest)
        : [...prev,interest]
    );
  };

  const handleSubmit=async (e)=> {
    e.preventDefault();
    if (!email) return;
    
    setIsLoading(true);
    setError('');
    
    try {
      const response = await fetch('https://api.encharge.io/v1/hooks/b57aa044-cf05-4a0a-9b29-f0082c9ba4ef', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          interests: interests,
          source: 'mindflow-landing',
          timestamp: new Date().toISOString()
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to submit. Please try again.');
      }

      setIsSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
      console.error('Submission error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  if (isSubmitted) {
    return (
      <section id="early-access" className="lead-capture-section">
        <div className="container mx-auto px-6 py-20">
          <motion.div 
            className="success-message"
            initial={{scale: 0.9,opacity: 0}}
            animate={{scale: 1,opacity: 1}}
            transition={{duration: 0.5}}
          >
            <div className="success-icon">
              <SafeIcon icon={FiCheck} />
            </div>
            <h2>You're on the list!</h2>
            <p>
              Thanks for joining our community of brilliant,neurodivergent minds. 
              We'll keep you updated on our progress and let you know as soon as 
              MindFlow is ready for early access.
            </p>
            <p className="success-note">
              No spam,just updates when we have something worth sharing.
            </p>
          </motion.div>
        </div>
      </section>
    );
  }

  return (
    <section id="early-access" className="lead-capture-section">
      <div className="container mx-auto px-6 py-20">
        <motion.div 
          className="lead-capture-content"
          initial={{y: 20,opacity: 0}}
          whileInView={{y: 0,opacity: 1}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
        >
          <div className="capture-header">
            <h2 className="capture-title">
              Ready to stop fighting your brain?
            </h2>
            <p className="capture-description">
              Join our early access list and be the first to experience productivity 
              that actually works with your neurodivergent brain,not against it.
            </p>
          </div>
          
          <form onSubmit={handleSubmit} className="capture-form">
            {error && (
              <div className="error-message" style={{color: '#ef4444', marginBottom: '1rem', textAlign: 'center'}}>
                {error}
              </div>
            )}
            
            <div className="email-input-group">
              <div className="input-wrapper">
                <SafeIcon icon={FiMail} className="input-icon" />
                <input
                  type="email"
                  value={email}
                  onChange={(e)=> setEmail(e.target.value)}
                  placeholder="your.brilliant.brain@example.com"
                  className="email-input"
                  required
                />
              </div>
              <motion.button 
                type="submit"
                className={`submit-btn ${isLoading ? 'loading' : ''}`}
                disabled={isLoading || !email}
                whileHover={{scale: 1.02}}
                whileTap={{scale: 0.98}}
              >
                {isLoading ? 'Adding you...' : 'Get Early Access'}
                <SafeIcon icon={FiArrowRight} />
              </motion.button>
            </div>
            
            <div className="interests-section">
              <p className="interests-label">
                Help us understand you better (optional):
              </p>
              <div className="interests-grid">
                {interestOptions.map((interest,index)=> (
                  <motion.button
                    key={index}
                    type="button"
                    className={`interest-tag ${interests.includes(interest) ? 'selected' : ''}`}
                    onClick={()=> handleInterestToggle(interest)}
                    whileHover={{scale: 1.02}}
                    whileTap={{scale: 0.98}}
                  >
                    {interest}
                    {interests.includes(interest) && (
                      <SafeIcon icon={FiCheck} className="check-icon" />
                    )}
                  </motion.button>
                ))}
              </div>
            </div>
            
            <p className="privacy-note">
              We respect your inbox and your time. No spam,just updates when we 
              launch and occasional insights about building for neurodivergent minds.
            </p>
          </form>
        </motion.div>
      </div>
    </section>
  );
};

export default LeadCaptureSection;